import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useFieldArray } from "react-hook-form";
import {
  BOB_SERVICES,
  I_POP_OVER,
  POSITIONS,
  POTENTIAL_PURPOSES,
  POTENTIAL_PURPOSE_COMPANIES,
  POTENTIAL_PURPOSE_PRODUCT_SERVICES,
  POTENTIAL_PURPOSE_PROFILES,
  PROFILE_STATUS,
  SELECT_BOX_THEME,
  country
} from "../../constants";
import Select from "react-select";
import SuccessModal from "./SuccessModal";
import { useState } from "react";
import {
  addBusinessProfile,
  editBusinessProfile,
} from "../../actions/bookOfBusiness";
import { useDispatch, useSelector } from "react-redux";
import InfoModalStatic from "../../components/infoModal/infoModalStatic";

export const getPotentialPurpose = (company) => {
  var position = null;
  var service = null;
  if (company) {
    if ('bookOfBusinessGroupId' in company) {
      position = company?.bookOfBusinessGroupId?.position || null
      service = company?.bookOfBusinessGroupId?.service || null
    } else {
      position = Array.isArray(company?.bookOfBusinessGroup) ? company?.bookOfBusinessGroup[0]?.position : null || null
      service = Array.isArray(company?.bookOfBusinessGroup) ? company?.bookOfBusinessGroup[0]?.service : null || null
    }

    if (position && service) {
      var positionList = BOB_SERVICES.PROFILES === service ? POTENTIAL_PURPOSE_PROFILES : BOB_SERVICES.PRODUCT_AND_SERVICES === service ? POTENTIAL_PURPOSE_PRODUCT_SERVICES : BOB_SERVICES.COMPANIES === service ? POTENTIAL_PURPOSE_COMPANIES : []
      return positionList.filter(x => x.value === position)[0]?.name || null
    }
  } else {
    return ""
  }
}


export default function ProfileForm({
  formOpen,
  formClose,
  companyDetail,
  bobSelected,
  isEdit,
  setIsEdit,
  limit,
  setStatus,
  status,
  setPage,
  setActivePage,
  bookOfBusiness
}) {

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
    reset,
    watch,
  } = useForm({ mode: "onChange" });
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const [successOpen, setSuccessOpen] = useState();
  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);
  const [skillInput, setSkillInput] = useState("");
  const [skillError, setSkillError] = useState("");


  const {
    fields: emailFields,
    append: appendEmail,
    remove: removeEmail,
  } = useFieldArray({
    control,
    name: "email",
  });

  const {
    fields: mobileFields,
    append: appendMobile,
    remove: removeMobile,
  } = useFieldArray(
    {
      control,
      required: true,
      name: "number",
    },
    {
      control,
      required: true,
      name: "areaCode",
    }
  );

  const {
    fields: expFields,
    append: appendExp,
    remove: removeExp,
  } = useFieldArray({
    control,
    name: 'experience',
  });

  const {
    fields: eduFields,
    append: appendEdu,
    remove: removeEdu,
  } = useFieldArray({
    control,
    name: 'education',
  });

  const {
    fields: langFields,
    append: appendLang,
    remove: removeLang,
  } = useFieldArray({
    control,
    name: 'languages',
  });

  const { fields: websiteFields, append: appendWebsite, remove: removeWebsite } =
    useFieldArray({ control, name: "website" });


  const handleclose = () => {
    reset();
    setIsEdit(false);
    formClose();
  };


  const isFilled = (v) => v !== undefined && v !== null && String(v).trim() !== "";

  const canAppendEmail = () => {
    const emails = getValues("email") || [];
    const last = emails[emails.length - 1];
    return isFilled(last);
  };

  const canAppendWebsite = () => {
    const websites = getValues("website") || [];
    const last = websites[websites.length - 1];
    return isFilled(last?.url);
  };

  const canAppendExperience = () => {
    const exp = getValues("experience") || [];
    const last = exp[exp.length - 1];
    return (
      isFilled(last?.title) &&
      isFilled(last?.company)
    );
  };

  const canAppendEducation = () => {
    const edu = getValues("education") || [];
    const last = edu[edu.length - 1];
    return isFilled(last?.school);
  };

  const canAppendLanguage = () => {
    const langs = getValues("languages") || [];
    const last = langs[langs.length - 1];
    return isFilled(last);
  };


  useEffect(() => {
    // var designation = POSITIONS.filter(
    //   (x) =>
    //     x?.value ===
    //     parseInt(
    //       companyDetail?.position || companyDetail?.defaultDesignationRole || 1
    //     )
    // )[0];
    // setValue("designation", designation);
    if (!isEdit) {
      return;
    }
    if (isEdit && bobSelected) {
      setValue("first_name", bobSelected?.first_name);
      setValue("last_name", bobSelected?.last_name);
      setValue("email", bobSelected?.email);
      bobSelected?.email?.forEach((email, index) => {
        setValue(`email[${index}]`, email);
      });
      setValue("number", bobSelected?.mobileNumber);
      bobSelected?.mobileNumber?.forEach((number, index) => {
        setValue(`areaCode[${index}]`, number?.areaCode);
        setValue(`number[${index}]`, number?.number);
      });
      setValue("companyName", bobSelected?.company?.companyName);
      setValue(
        "position",
        POSITIONS.filter(
          (x) => x.value === parseInt(bobSelected?.position)
        )[0]?.name
      );
      setValue("industry", bobSelected?.industry);
      setValue("linkdin", bobSelected?.linkedinUrl);
      setValue("country", bobSelected?.country);
      setValue("companyProfile", bobSelected?.companyProfile);
      setValue("positionProfile", bobSelected?.positionProfile);

      setValue("serviceProductName", bobSelected?.serviceProductName);
      setValue("description", bobSelected?.description);
      setValue("landingPageUrl", bobSelected?.landingPageUrl);
      setValue("companyType", bobSelected?.companyType);
      setValue("potentialPurpose", bobSelected?.potentialPurpose);
      if (companyDetail?.bookOfBusinessGroupId?.isDefault) {
        setValue("customPotentialPurposeInput", POTENTIAL_PURPOSES.find(x => x.value === bobSelected?.customPotentialPurposeInput))
      };

    }
  }, [setValue, isEdit, bobSelected, formOpen]);

  useEffect(() => {
    if (emailFields.length === 0) {
      appendEmail("");
    }
    if (mobileFields.length === 0) {
      appendMobile("");
    }
    if (expFields.length === 0) {
      appendExp({
        title: '',
        company: '',
        duration: '',
        location: '',
        roles: [], // very important
      });
    }
    if (eduFields.length === 0) {
      appendEdu({
        school: '',
        credential: '',
        dates: '',
      });
    }
    if (langFields.length === 0) {
      appendLang('');
    }
    if (websiteFields.length === 0) {
      appendWebsite({ url: '' });
    }


  }, [emailFields, mobileFields, appendEmail, appendMobile,
    expFields, appendExp, eduFields, appendEdu, langFields, appendLang, websiteFields, appendWebsite]);



  const cleanEducation = (edu = []) =>
    edu.filter(e =>
      isFilled(e?.school) ||
      isFilled(e?.credential) ||
      isFilled(e?.dates)
    );

  const cleanRoles = (roles = []) =>
    roles.filter(r =>
      isFilled(r?.title) ||
      isFilled(r?.employmentType) ||
      isFilled(r?.duration) ||
      isFilled(r?.location)
    );

  const cleanExperience = (exp = []) =>
    exp
      .map(e => ({
        ...e,
        roles: cleanRoles(e?.roles || []),
      }))
      .filter(e =>
        isFilled(e?.title) ||
        isFilled(e?.company) ||
        isFilled(e?.duration) ||
        isFilled(e?.location) ||
        (e.roles && e.roles.length > 0)
      );

  const cleanWebsites = (websites = []) =>
    websites.filter(w => isFilled(w?.url));

  const cleanEmails = (emails = []) =>
    emails.filter(e => isFilled(e));

  const cleanPhones = (numbers = [], areaCodes = []) =>
    numbers
      .map((n, i) => ({
        areaCode: areaCodes?.[i] || null,
        number: n,
      }))
      .filter(p => isFilled(p?.number));

  const cleanLanguages = (langs = []) =>
    langs.filter(l => isFilled(l));


  const onSubmit = async (data) => {
    if (data) {
      const cleanedEducation = cleanEducation(data?.education);
      const cleanedExperience = cleanExperience(data?.experience);
      const cleanedWebsites = cleanWebsites(data?.website);
      const cleanedEmails = cleanEmails(data?.email);
      const cleanedPhones = cleanPhones(data?.number, data?.areaCode);
      const cleanedLanguages = cleanLanguages(data?.languages);
      let payloadnew = {
        userids: companyDetail ? companyDetail?.user[0]?._id || companyDetail?.user[0]?.id : user?.id,
        company: companyDetail ? companyDetail?.id || companyDetail?._id : "",
        name: (data?.first_name || "") + " " + (data?.last_name || ""),
        salesNavUrl: "",
        linkedinUrl: data.linkdin || null,
        imageUrl: data?.imageUrl || "",
        location: data?.country || "",
        about: data?.about || "",
        person_industry: data?.person_industry || null,
        customPotentialPurposeInput: data?.customPotentialPurposeInput?.value || '',
        status: 1,
        headline: data.headline || null,
        isTemp: data?.isTemp || false,
        skills: data?.skills || [],
        experience: cleanedExperience,
        education: cleanedEducation,
        languages: cleanedLanguages,
        contactInfo: {
          website: cleanedWebsites,
          email: cleanedEmails,
          phone: cleanedPhones,
        },
      }
      var resp = null;
      if (isEdit) {
        resp = await dispatch(
          editBusinessProfile(
            payloadnew,
            companyDetail?._id,
            bobSelected?.id
          )
        );
      } else {
        resp = await dispatch(
          addBusinessProfile(payloadnew, companyDetail?._id)
        );
      }
      reset();
      formClose();
      setPage(1);
      setActivePage(0);
      if (resp && resp.status) {
        setSuccessOpen(resp.details);
        setStatus(status);
      }
    }
  };

  const isFieldEmpty = (index) => {
    const areaCodeValue = watch(`areaCode.${index}`);
    const numberValue = watch(`number.${index}`);
    return areaCodeValue && numberValue;
  };

  const handleClickInfo = (type) => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };
  const handleAddSkill = () => {
    const value = skillInput.trim();

    if (!value) return;

    const skills = getValues("skills") || [];

    // duplicate check (case insensitive)
    if (skills.some((s) => s.toLowerCase() === value.toLowerCase())) {
      setSkillError("This skill is already added");
      return;
    }

    setSkillError("");

    setValue("skills", [...skills, value], {
      shouldValidate: true,
    });

    setSkillInput("");
  };



  return (
    <>
      <Modal
        show={formOpen}
        onHide={handleclose}
        className="moddal-primary importModal ps-0"
      >
        <Modal.Body>
          <div className="header">
            <div>
              <h4>Add profile</h4>
              {companyDetail &&
                <p>
                  Account name:{" "}
                  <span>{companyDetail?.companyName || "-"}</span>{" "}
                  Suggested by:{" "}
                  <span>
                    {companyDetail?.user[0]?.first_name} {companyDetail?.user[0]?.last_name}
                  </span>{" "}
                </p>
              }
            </div>
            <i onClick={handleclose} className="fa-solid fa-xmark"></i>
          </div>
          <div className="modalBody">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="labelForm" htmlFor="">
                    First name *
                  </label>
                  <input
                    maxLength={50}
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    placeholder="Insert first name"
                    {...register("first_name", { required: true })}
                  />
                  {errors.first_name?.type === "required" && (
                    <span className="errorMessage">First name is required</span>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="labelForm" htmlFor="">
                    Last name *
                  </label>
                  <input
                    maxLength={50}
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    placeholder="Insert last name"
                    {...register("last_name", { required: true })}
                  />
                  {errors.last_name?.type === "required" && (
                    <span className="errorMessage">Last name is required</span>
                  )}
                </div>

                <div className="col-md-6">
                  {emailFields.map((field, index) => (
                    <div
                      key={field.id}
                      className="col-lg-12 fieldPadding"
                      style={{ position: "relative" }}
                    >
                      <label className="labelForm" htmlFor="">
                        Email address {index > 0 ? index + 1 : ""}
                      </label>
                      <div className="removeBtnContainer">
                        {index > 0 && (
                          <div
                            onClick={() => removeEmail(index)}
                            className="removeBtn"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        )}
                        <input
                          autoComplete="off"
                          type="text"
                          className="form-control"
                          placeholder="Insert email address"
                          {...register(`email.${index}`, {
                            required: false,
                            pattern: {
                              value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                              message: "Invalid email format",
                            },
                            validate: {
                              isUnique: (value) => {
                                // Check if the email is unique
                                const emails = getValues("email");
                                return (
                                  emails.findIndex((item) => item === value) ===
                                  index ||
                                  "Email already exists, please use another email"
                                );
                              },
                            },
                          })}
                        />
                      </div>
                      {errors?.email?.[index] && (
                        <span className="errorMessage">
                          {errors.email?.[index].message}
                        </span>
                      )}
                    </div>
                  ))}
                  <div className="col-lg-6">
                    <div
                      onClick={() => {
                        if (!canAppendEmail()) return;
                        appendEmail("");
                      }} className="addMoreFeature"
                    >
                      <img src="assets/img/plusBtn.svg" alt="" />
                      Add email address
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  {mobileFields.map((field, index) => (
                    <div className="row" key={field.id}>
                      <div
                        className="col-lg-4 fieldPadding"
                        style={{ position: "relative" }}
                      >
                        <label className="labelForm" htmlFor="">
                          Country code {index > 0 ? index + 1 : ""}
                        </label>

                        <Controller
                          name={`areaCode.${index}`}
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Select
                              className="select-border"
                              theme={SELECT_BOX_THEME}
                              value={field.value}
                              onChange={(value) => field.onChange(value)}
                              options={country}
                              isClearable={true}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  whiteSpace: "nowrap",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  fontSize: "12px"
                                })
                              }}
                              getOptionLabel={(option) =>
                                `${option.dial_code} (${option.name})`
                              }
                              getOptionValue={(option) => option.dial_code}
                              placeholder="Country code"
                              components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                            />
                          )}
                        />
                      </div>
                      <div
                        className="col-lg-8 fieldPadding"
                        style={{ position: "relative" }}
                      >
                        <label className="labelForm" htmlFor="">
                          Mobile number {index > 0 ? index + 1 : ""}
                        </label>
                        <div className="removeBtnContainer">

                          {index > 0 && (
                            <div
                              onClick={() => removeMobile(index)}
                              className="removeBtn"
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </div>
                          )}
                          <input
                            autoComplete="off"
                            type="number"
                            className="form-control"
                            placeholder="Mobile number"
                            {...register(`number.${index}`, {
                              required: false,
                              validate: {
                                isUnique: (value) => {
                                  // Check if the email is unique
                                  const number = getValues("number");
                                  return (
                                    number.findIndex((item) => item === value) ===
                                    index ||
                                    "Mobile number already exists, please use another number"
                                  );
                                },
                              },
                            })}
                          />
                        </div>
                      </div>
                      {errors?.number?.[index] && (
                        <span className="errorMessage">
                          {errors.number?.[index].message}
                        </span>
                      )}
                      {errors?.areaCode?.[index] && (
                        <span className="errorMessage">
                          {errors.areaCode?.[index].message}
                        </span>
                      )}
                    </div>
                  ))}
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-lg-6">
                      <div
                        onClick={() =>
                          isFieldEmpty(mobileFields.length - 1) &&
                          appendMobile("")
                        }
                        className="addMoreFeature"
                      >
                        <img src="assets/img/plusBtn.svg" alt="" />
                        Add mobile number
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  {websiteFields.map((field, index) => (
                    <div key={field.id} className="fieldPadding">
                      <label className="labelForm">Website {index > 0 ? index + 1 : ""}</label>
                      <div className="removeBtnContainer">
                        {index > 0 && (
                          <div
                            onClick={() => removeWebsite(index)}
                            className="removeBtn"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        )}
                        <input
                          className="form-control"
                          placeholder="Enter website URL"
                          {...register(`website.${index}.url`)}
                        />
                      </div>
                    </div>
                  ))}
                  <div onClick={() => {
                    if (!canAppendWebsite()) return;
                    appendWebsite({ url: "" });
                  }} className="addMoreFeature">
                    <img src="assets/img/plusBtn.svg" alt="" />
                    Add website
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="labelForm">Skills</label>

                  <div className={`skillsInputWrapper ${errors.skills || skillError ? "errorBorder" : ""}`}>
                    <input
                      type="text"
                      className="skillsInput"
                      value={skillInput}
                      placeholder="Type a skill and press Enter"
                      onChange={(e) => {
                        setSkillInput(e.target.value);
                        setSkillError("");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleAddSkill();
                        }
                      }}
                    />

                    <button
                      type="button"
                      className="skillAddBtn"
                      onClick={handleAddSkill}
                    >
                      Add
                    </button>
                  </div>

                  {/* Errors */}
                  {errors.skills && (
                    <span className="errorMessage">{errors.skills.message}</span>
                  )}
                  {skillError && (
                    <span className="errorMessage">{skillError}</span>
                  )}

                  {/* Chips */}
                  <div className="skillsChips">
                    {(watch("skills") || []).map((skill, index) => (
                      <div key={index} className="skillChip">
                        {skill}
                        <span
                          className="removeSkill"
                          onClick={() =>
                            setValue(
                              "skills",
                              watch("skills").filter((_, i) => i !== index),
                              { shouldValidate: true }
                            )
                          }
                        >
                          ×
                        </span>
                      </div>
                    ))}
                  </div>
                </div>


                <div className="col-md-6">

                  {expFields.map((item, index) => (
                    <div key={item.id} className="expCard">
                      <div className="removeBtnContainer">
                        <label className="labelForm">Experience {index > 0 ? index + 1 : ""}</label>
                        {index > 0 && (
                          <div
                            onClick={() => removeExp(index)}
                            className="removeBtn"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        )}
                      </div>
                      <input
                        className="form-control"
                        placeholder="Title"
                        {...register(`experience.${index}.title`)}
                      />
                      <input
                        className="form-control mt-2"
                        placeholder="Company"
                        {...register(`experience.${index}.company`)}
                      />
                      <input
                        className="form-control mt-2"
                        placeholder="Duration"
                        {...register(`experience.${index}.duration`)}
                      />
                      <input
                        className="form-control mt-2"
                        placeholder="Location"
                        {...register(`experience.${index}.location`)}
                      />


                    </div>
                  ))}

                  <div
                    onClick={() => {
                      if (!canAppendExperience()) return;
                      appendExp({ title: "", company: "", duration: "", location: "", roles: [] });
                    }}

                    className="addMoreFeature"
                  >
                    Add Experience
                  </div>
                </div>

                <div className="col-md-6">

                  {eduFields.map((item, index) => (
                    <div key={item.id} className="expCard">
                      <div className="removeBtnContainer">
                        <label className="labelForm">Education {index > 0 ? index + 1 : ""}</label>
                        {index > 0 && (
                          <div
                            onClick={() => removeEdu(index)}
                            className="removeBtn"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        )}
                      </div>
                      <input
                        className="form-control"
                        placeholder="School"
                        {...register(`education.${index}.school`)}
                      />
                      <input
                        className="form-control mt-2"
                        placeholder="Credential"
                        {...register(`education.${index}.credential`)}
                      />
                      <input
                        className="form-control mt-2"
                        placeholder="Dates"
                        {...register(`education.${index}.dates`)}
                      />
                    </div>
                  ))}

                  <div onClick={() => {
                    if (!canAppendEducation()) return;
                    appendEdu({ school: "", credential: "", dates: "" });
                  }}
                    className="addMoreFeature">
                    Add Education
                  </div>
                </div>


                <div className="col-md-6">
                  {langFields.map((item, index) => (
                    <div key={item.id} className="fieldPadding">
                      <div className="removeBtnContainer">
                        <label className="labelForm">Languages {index > 0 ? index + 1 : ""}</label>
                        {index > 0 && (
                          <div
                            onClick={() => removeLang(index)}
                            className="removeBtn"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        )}
                      </div>
                      <input
                        className="form-control"
                        placeholder="Language"
                        {...register(`languages.${index}`)}
                      />
                    </div>
                  ))}

                  <div onClick={() => {
                    if (!canAppendLanguage()) return;
                    appendLang("");
                  }} className="addMoreFeature">
                    Add Language
                  </div>
                </div>



                {/* {companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.PROFILES && (
                  <>
                    <div className="col-md-6">
                      <label className="labelForm" htmlFor="">
                        Company
                      </label>
                      <input
                        maxLength={50}
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder="Insert Company Profile"
                        {...register("companyProfile", { required: false })}
                      />
                      {errors.companyProfile?.type === "required" && (
                        <span className="errorMessage">
                          Company profile name is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="labelForm" htmlFor="">
                        Position
                      </label>
                      <input
                        maxLength={50}
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder="Insert position"
                        {...register("positionProfile", { required: false })}
                      />
                      {errors.positionProfile?.type === "required" && (
                        <span className="errorMessage">
                          Position profile is required
                        </span>
                      )}
                    </div>
                  </>
                )} */}



                <div className="col-md-6">
                  <label className="labelForm" htmlFor="">
                    Country
                  </label>
                  <Controller
                    name="country"
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <Select
                        className="select-border"
                        theme={SELECT_BOX_THEME}
                        value={field.value}
                        onChange={(value) => field.onChange(value)}
                        options={country}
                        isClearable={true}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.name}
                        placeholder="Select Country"
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    )}
                  />
                  {errors.country?.type === "required" && (
                    <span className="errorMessage">Country is required</span>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="labelForm" htmlFor="">
                    LinkedIn profile URL*
                  </label>
                  <input
                    maxLength={200}
                    autoComplete="off"
                    type="text"
                    className="form-control"
                    placeholder="Insert linkedIn profile URL"
                    {...register("linkdin", {
                      required: "Linkedin profile URL is required",
                      pattern: {
                        value: /^https:\/\/www\.linkedin\.com+/,
                        message: "Please enter a valid linkedin URL",
                        // https://www.linkedin.com/ this is required
                      },
                    })}
                  // defaultValue="https://www.linkedin.com"
                  />
                  {errors.linkdin && (
                    <span className="errorMessage">
                      {errors.linkdin.message}
                    </span>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="labelForm">About *</label>
                  <textarea
                    className="form-control"
                    placeholder="Insert about"
                    {...register("about", { required: "About is required" })}
                  />
                  {errors.about && <span className="errorMessage">{errors.about.message}</span>}
                </div>

                <div className="col-md-6">
                  <label className="labelForm" htmlFor="">
                    Industry
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Industry"
                    {...register("industry", {
                      required: false,
                    })}
                  />
                  {/* <Controller
                    name="industry"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        isMulti
                        className="select-border"
                        theme={SELECT_BOX_THEME}
                        value={field.value}
                        onChange={(value) => field.onChange(value)}
                        options={industry}
                        isClearable={true}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        placeholder="Select Industry"
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    )}
                  /> */}
                  {errors.industry?.type === "required" && (
                    <span className="errorMessage">Industry is required</span>
                  )}
                </div>



                {/* {(companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.COMPANIES || companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.PRODUCT_AND_SERVICES) && (
                  <>
                    <div className="col-md-6">
                      <label className="labelForm" htmlFor="">
                        One sentence summary
                      </label>
                      <textarea
                        maxLength={50}
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder="One sentence summary"
                        {...register("description", false)}
                      />
                    </div>
                  </>
                )} */}
              </div>

              <div className="note">
                <p className="desc">
                  <span>IMPORTANT NOTE:</span> Lorem ipsum velit officia
                  consequat duis enim velit mollit.
                </p>
              </div>

              <div className="importBtn">
                <button
                  type="submit"
                  // disabled={!isValid}
                  className="customAddButton removePadding"
                >
                  {isEdit ? "Edit " : "Add "}
                  {(companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.PROFILES) ? (
                    "profile"
                  ) : (companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.COMPANIES) ? (
                    "company"
                  ) : (companyDetail?.bookOfBusinessGroup[0]?.service === BOB_SERVICES.PRODUCT_AND_SERVICES) ? (
                    "Service or Product"
                  ) : ("")}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <SuccessModal
        successOpen={successOpen}
        successClose={() => setSuccessOpen(false)}
        isEdit={isEdit}
        reset={reset}
        status={status}
      />
      <InfoModalStatic
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={infoModalStaicShowType}
      />
    </>
  );
}
